import React from "react";

import { Dropdown } from "primereact/dropdown";

function CustomDropdown({
  className = null,
  value = null,
  onChange = () => {},
  options = [],
  placeholder = null,
  optionLabel = null,
  optionValue = null,
  isFilter = false,
  style = {},
  valueTemplate,
  optionTemplate = () => {},
}) {
  return (
    <Dropdown
      className={className}
      style={style}
      filter={isFilter}
      optionLabel={optionLabel}
      optionValue={optionValue}
      value={value}
      defaultValue={"Choose Font"}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      valueTemplate={valueTemplate}
      itemTemplate={optionTemplate}
    />
  );
}

export default CustomDropdown;
